/**
 * Redux slice for Email Events Management
 */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as emailService from "../services/emailEventService";

/* ============================
   Async Thunks
============================ */

export const getEmailEvents = createAsyncThunk(
  "emailEvents/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const response = await emailService.fetchEmailEvents(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching events");
    }
  }
);

export const getEmailEventDetail = createAsyncThunk(
  "emailEvents/getDetail",
  async ({ eventId, params }, { rejectWithValue }) => {
    try {
      const response = await emailService.fetchEmailEventDetail(eventId, params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching event detail");
    }
  }
);

/* ============================
   Slice
============================ */

const emailEventSlice = createSlice({
  name: "emailEvents",
  initialState: {
    events: [],
    pagination: null,
    eventDetail: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // LIST
      .addCase(getEmailEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEmailEvents.fulfilled, (state, action) => {
        state.loading = false;

        // Store paginated results properly
        state.events = action.payload.results || [];
        state.pagination = {
          count: action.payload.count,
          totalPages: action.payload.total_pages,
          currentPage: action.payload.current_page,
          pageSize: action.payload.page_size,
        };
      })
      .addCase(getEmailEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DETAIL
      .addCase(getEmailEventDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEmailEventDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.eventDetail = action.payload;
      })
      .addCase(getEmailEventDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default emailEventSlice.reducer;